import { Stack } from '@mui/material';
import { Restricted } from '@procureai/permissions-ui';
import { NavBar, NavBarProps, NavFooter, NavListItemToolTipContent } from '@procureai/ui-mui';

import { appConfig } from '~/common/config';
import { FeatureFlag } from '~/common/types';

import { useAppNavBarConfig } from './AppNavBar.config';
import { NavListItemAvatar } from './components/NavListItemAvatar/NavListItemAvatar';
import { NavListItemLanguage } from './components/NavListItemLanguage/NavListItemLanguage';
import { NavListItemLink } from './components/NavListItemLink/NavListItemLink';
import { NavListItemScopeSelect } from './components/NavListItemScopeSelect/NavListItemScopeSelect';
import { NavListItemSupport } from './components/NavListItemSupport/NavListItemSupport';

export type AppNavBarProps = NavBarProps;

export const AppNavBar = ({ top, bottom, ...otherProps }: AppNavBarProps) => {
  const items = useAppNavBarConfig();

  return (
    <NavBar
      {...otherProps}
      top={
        <Stack
          spacing={2}
          sx={{
            mt: '10px',
          }}
        >
          <NavListItemAvatar />
          <Restricted needs={{ feature: FeatureFlag.SCOPE_SWITCHER }}>
            <NavListItemScopeSelect />
          </Restricted>

          {items.map((item) => (
            <NavListItemLink key={item.id} {...item} />
          ))}
        </Stack>
      }
      bottom={
        <Stack
          spacing={2}
          sx={{
            mt: '10px',
          }}
        >
          <NavListItemSupport />
          <NavListItemLanguage />
          <NavFooter
            bgcolor="alias.blackFriars"
            tooltip={<NavListItemToolTipContent label={`Version ${appConfig.version}`} />}
          >
            <img alt="logo" width={44} height={44} src={`/logo-square.svg`} />
          </NavFooter>
        </Stack>
      }
    />
  );
};
